module.exports = __webpack_public_path__ + "static/media/teammates.abf9b10c.svg";